import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  success: false,
  error: null,
  message: null,
  organizations: [],
  organization: null,
};


export const organizationReducer = createReducer(initialState, (builder) => {
  builder
    // Create Organization
    .addCase('createOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.organization = action.payload;
      state.success = true;
    })
    .addCase('createOrganizationFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Fetch All Organizations
    .addCase('getAllOrganizationsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllOrganizationsSuccess', (state, action) => {
      state.isLoading = false;
      state.organizations = action.payload;
    })
    .addCase('getAllOrganizationsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Fetch Single Organization
    .addCase('getOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.organization = action.payload;
    })
    .addCase('getOrganizationFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Load Current Organization
    .addCase('LoadOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('LoadOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.organization = action.payload;
    })
    .addCase('LoadOrganizationFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Edit Organization
    .addCase('editOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.organization = action.payload;
      state.success = true;
    })
    .addCase('editOrganizationFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Delete Organization
    .addCase('deleteOrganizationRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteOrganizationSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    })
    .addCase('deleteOrganizationFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })
    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});